<!-- 全职招聘 -->
<template>
  <div class="container">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <main-navigator :currentIndex="currentIndex"></main-navigator>
    <bread><span slot="nav" style="color:#00A0E9" >全职招聘</span></bread>
    <section class="main">
      <ul class="main-content">
        <router-link :to="'/recruitDetail?id='+item.id" v-for="(item,index) in recruitList" :key="index">
          <li class="item">
            <div class="left">
              <!-- <img src="../assets/recruit.png" alt=""> -->
            </div>
            <div class="right">
              <div class="des">
                <h3>{{item.title}}</h3>
                <span class="price">{{item.price}}</span>
                <span class="recruit">{{item.address}}</span>
                <p>
                  <span class="tag" v-for="tag in item.tag">{{item.tags}}</span>
                </p>
              </div>
              <span class="limit">{{item.limit}}</span>
              <span class="enroll">报名</span>
            </div>
          </li>
        </router-link>
         <ul class="pageNum">
            <li class="active" >1</li>
         </ul>
      </ul>
    </section>
  </div>
  
</template>

<script>
import qs from "qs";
import LoginNavigator from "../components/LoginNavigator";
import LogoHeader from "../components/LogoHeader";
import Bread from "../components/Bread";
import MainNavigator from "../components/MainNavigator";
export default {
  data() {
    return {
      arr: [0, 1, 2, 3, 4, 5],
      tag: ["五险一金", "包吃", "年底双薪"],
      currentIndex: 2,
      pageNum: 1,
      rindex: 0,
      recruitList: [
      ]
    };
  },
  components: {
    Bread,
    LoginNavigator,
    LogoHeader,
    MainNavigator
  },
  created() {
    this.rindex = parseInt(this.$route.query.id);
  },
  mounted() {
    this.getSecondInfo();
  },
  methods: {
    getSecondInfo: function() {
      var that = this,
        id = that.rindex;
      var postData = {
        id: id
      };
      that.$axios
        .post("http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getSecondInfo", qs.stringify(postData))
        .then(function(res) {
          var list = res.data.info;
          for (var i = 0, len = list.length; i < len; i++) {
            var time;
            var year, month, date, day;
            time = list[i].create_time;
            date = new Date(time);
            year = date.getFullYear();
            month = date.getMonth();
            day = date.getDay();
            list[i].date = year + "-" + month + "-" + day;
          }
          that.recruitList = list;
          console.log("reclist", that.recruitList);
        });
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  background: #f5f5f5;
}
footer {
  height: 100px;
  width: 100%;
  background: #fafafa;
}
.main {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 46px;
  background: #fff;
}
.main-content .item {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f2f4f5;
}
.main-content .left {
  padding: 10px 17px 10px 9px;
}
.main-content .left img {
  display: inline-block;
  width: 160px;
  height: 100px;
  background: #f2f4f5;
}
.main-content .right {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.main-content .right .des {
  display: flex;
  flex-direction: column;
}
.main-content .right .des .name {
  font-size: 16px;
  color: #333;
}
.main-content .right .des .price {
  font-size: 14px;
  color: #ff7e00;
  margin-top: 8px;
}
.main-content .right .des .recruit {
  font-size: 12px;
  color: #b3b3b3;
  margin: 8px 0;
}
.main-content .right .des p .tag {
  display: inline-block;
  width: 70px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 11px;
  background: #f2f4f5;
  color: #c2c8cc;
  margin-right: 12px;
}
.main-content .right .limit {
  font-size: 14px;
  color: #b3b3b3;
}
.main-content .right .enroll {
  width: 110px;
  height: 40px;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
  background: #00a0e9;
  color: #fff;
  margin-right: 40px;
}
.main .pageNum {
  margin-top: 40px;
  text-align: center;
}
.main .pageNum li {
  display: inline-block;
  width: 22px;
  height: 28px;
  background: #e6e6e6;
  color: #666;
  text-align: center;
  line-height: 28px;
  margin-right: 14px;
}
.main .pageNum .active {
  color: #fff;
  background: #00a0e9;
}
.main .pageNum .next {
  display: inline-block;
  width: 68px;
  height: 28px;
  color: #fff;
  background: #00a0e9;
  text-align: center;
  line-height: 28px;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/recruit.vue